import { AxiosResponse } from 'axios';
import { ShippingLine } from 'types/Shipping';
import { objectKeysToCamelCase, joinArrayParams } from 'utils/common';
import axiosWithToken from './axios-with-token';

interface ShippingLineEmailsRemote {
  additional: string;
  email_address: string;
  email_display: string;
}

interface ShippingLinePhoneNumbersRemote {
  additional: string;
  number: string;
  display: string;
}

interface ShippingLineWebsitesRemote {
  additional: string;
  url: string;
  link_display: string;
}

interface ShippingLineRemote {
  key: string;
  name: string;
  emails?: ShippingLineEmailsRemote[];
  phone_numbers: ShippingLinePhoneNumbersRemote[];
  websites: ShippingLineWebsitesRemote[];
}

export const enum ShippingLineQueryKeys {
  ShippingLines = 'shippingLines',
}

export interface ShippingLineFilters {
  portCollectionCodes?: string[];
}

interface ShippingLineArgument extends ShippingLineFilters {
  signal?: AbortSignal;
}

export async function fetchShippingLines({
  portCollectionCodes,
  signal = undefined,
}: ShippingLineArgument) {
  const response: AxiosResponse<ShippingLineRemote[]> = await axiosWithToken.get(
    '/core/api/v1/erl/shipping_line',
    {
      signal,
      params: {
        port_collection_codes: joinArrayParams(portCollectionCodes),
      },
    }
  );
  const shippingLines: ShippingLine[] = objectKeysToCamelCase(response.data);
  return shippingLines;
}
